import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { SessionService } from '../commons/session.service';
import { CartService } from '../commons/cart.service';
import { SessionState } from '../commons/models';

@Injectable()
export class UtilitiesService {


  // @ViewChild('txtUserName') txtUserName: ElementRef;
  // @ViewChild('txtPassword') txtPassword: ElementRef;

  constructor(
    private _http: Http,
    public session: SessionService,
    public cartService: CartService
  ) { }

  // Data un'immagine, torna la relativa stringa in base64, per poterla salvare nello storage
  public getBase64Image(img) {

    let canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;

    let ctx = canvas.getContext('2d');

    // Flip
    // ctx.translate(canvas.width, 0);
    // ctx.scale(-1, 1);

    ctx.drawImage(img, 0, 0);

    let dataURL = canvas.toDataURL('image/jpeg', 1);

    return dataURL;
  }

  public FlipImage(imgSrc) {

    let img = document.createElement('img');
    img.src = imgSrc;

    let canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;

    let ctx = canvas.getContext('2d');

    ctx.translate(canvas.width, 0);
    ctx.scale(-1, 1);

    ctx.drawImage(img, 0, 0);

    let dataURL = canvas.toDataURL('image/jpeg', 0.5);

    return dataURL;
  }

  private setLoginData(user: any) {
    this.cartService.cart.customer.Email = user.Email;
    this.cartService.cart.customer.Phone = user.PhoneNumber;
    this.cartService.cart.customer.Name = user.Customer.Name;
    this.cartService.cart.customer.Surname = user.Customer.Surname;
    this.cartService.cart.customer.TaxCode = user.Customer.TaxCode;
    this.cartService.cart.customer.VatNumber = user.Customer.VatNumber;

    this.cartService.cart.billing.Email = user.Email;
    this.cartService.cart.billing.Phone = user.PhoneNumber;
    this.cartService.cart.billing.Name = user.Billing.Name;
    this.cartService.cart.billing.Surname = user.Billing.Surname;
    this.cartService.cart.billing.TaxCode = user.Billing.TaxCode;
    this.cartService.cart.billing.VatNumber = user.Billing.VatNumber;
    this.cartService.cart.billing.CodeSDI = user.Billing.CodeSDI;
    this.cartService.cart.billing.PEC = user.Billing.PEC;

    this.cartService.cart.shipmentAddress.City = user.Address.City;
    this.cartService.cart.shipmentAddress.Country = user.Address.Country;
    this.cartService.cart.shipmentAddress.District = user.Address.District;
    this.cartService.cart.shipmentAddress.Extended = user.Address.Extended;
    this.cartService.cart.shipmentAddress.Locality = user.Address.Locality;
    this.cartService.cart.shipmentAddress.PostalCode = user.Address.PostalCode;
    this.cartService.cart.shipmentAddress.Street = user.Address.Street;

    this.cartService.cart.billingAddress.City = user.Address.City;
    this.cartService.cart.billingAddress.Country = user.Address.Country;
    this.cartService.cart.billingAddress.District = user.Address.District;
    this.cartService.cart.billingAddress.Extended = user.Address.Extended;
    this.cartService.cart.billingAddress.Locality = user.Address.Locality;
    this.cartService.cart.billingAddress.PostalCode = user.Address.PostalCode;
    this.cartService.cart.billingAddress.Street = user.Address.Street;
  }

  public cartTOTAL(cartTOTALUpdated = null) {

    this.cartService.cart.recalculateDeliveryPrice();

    if (this.cartService.cart.cartProducts.length > 0) {
      this.cartService.cart.totalPriceProducts =
        this.cartService.cart.cartProducts.map(r => r.totalPrice()).reduce(this.cartService.cart.getSum);
    } else {
      this.cartService.cart.totalPriceProducts = 0;
    }
    this.cartService.cart.totalALLPriceStatic = this.cartService.cart.totalPriceProducts + this.cartService.cart.delivPrice;
    // if (this.cartService.cart.couponLabel) {
    //   coupon = this.cartService.cart.couponLabel;
    // }
    this.CalculateCoupon(this.cartService.cart.couponLabel, cartTOTALUpdated);

    //console.log('cartTOTAL ' + this.cartService.cart.couponLabel, cartTOTALUpdated);

    if (this.cartService.cart.totalALLPriceStatic !== this.cartService.cart.TOTALCartORDER) {
      console.log('ATTENZIONE !!!!',
        'this.TOTALCartORDER: ' + this.cartService.cart.TOTALCartORDER
        + ' - this.totalALLPriceStatic: ' + this.cartService.cart.totalALLPriceStatic);
    } else {
      console.log('OK totali');
    }

  }


  public CalculateCoupon(coupon: string = null, cartTOTALUpdated = null, alertCoupon = false) {

    // let couponPass = new CouponData();
    // couponPass.couponEmail = this.cartService.cart.customer.Email;
    // couponPass.totalPrice = this.cartService.cart.totalALLPriceStatic;

    // if (coupon) {
    //   couponPass.couponLabel = coupon;
    // } else {
    //   couponPass.couponLabel = this.cartService.cart.couponLabel;
    // }

    // IMPOSTO TEMPORANEAMENTE IL COUPON NEL CARRELLO, SE NON VA A BUON FINE LO RESETTO
    this.cartService.cart.couponLabel = coupon;
    this.cartService.cart.couponEmail = this.cartService.cart.customer.Email;

    // 10-04-2018 passo il carrello con i prodotti per poterli ciclare ed applicare lo sconto ev. solo su alcuni
    this.requestAngular2('coupon', this.cartService.cart).subscribe(
      result => {

        if (result.result === 'ok') {

          this.cartService.cart.TOTALCartORDER = result.newTotal;
          if (alertCoupon) {
            alert('CODICE SCONTO APPLICATO CORRETTAMENTE');
          }
        } else {
          if (alertCoupon) {
            alert(result.message);
          }
          //console.log(result.result, result.message);

          this.cartService.cart.TOTALCartORDER = this.cartService.cart.totalALLPriceStatic;
          this.cartService.cart.couponLabel = null;
          this.cartService.cart.couponEmail = null;

        }


        //console.log('cartTOTAL', this.cartService.cart.TOTALCartORDER);
        if (cartTOTALUpdated) {
          cartTOTALUpdated(this.cartService.cart.TOTALCartORDER);
        }
      },
      error => {
        console.error(error);
        //console.log(error.result, error.message);

        this.cartService.cart.TOTALCartORDER = this.cartService.cart.totalALLPriceStatic;
        this.cartService.cart.couponLabel = null;
        this.cartService.cart.couponEmail = null;
      }
    );
  }

  public AutoLogin(sessionState: SessionState) {
    console.log('AutoLogin');
    this.requestAngular2('autologin', sessionState).subscribe(
      result => {
        console.log(result);
        // se login ok precompilo i dati
        if (result.Item1 === 'ok') {
          console.log(result.User);
          this.setLoginData(result.Item2);
        } else {
          console.log(result.Item1);
          alert('Login fallito\r\nDati errati');
        }
      },
      error => {
        console.error(error);
      }
    );
  }

  public Login() {
    console.log('Login');
    let txtUserName = <HTMLInputElement>document.getElementById('txtUserName');
    let txtPassword = <HTMLInputElement>document.getElementById('txtPassword');

    // ViewChild non funziona perchè in un componente interno, provare ViewChildren od altro.
    // let txtUserName = this.txtUserName.nativeElement;
    // let txtPassword = this.txtPassword.nativeElement;

    // console.log(txtPassword.value + txtUserName.value);

    let body = {
      username: txtUserName.value,
      password: txtPassword.value
    };

    this.requestAngular2('login', body).subscribe(
      result => {
        console.log(result);
        // se login ok precompilo i dati
        if (result.Item1 === 'ok') {
          console.log(result.User);
          this.setLoginData(result.Item2);

          $('#mdLoginBox').modal('hide');
        } else {
          console.log(result.Item1);
          alert('Login fallito\r\nDati errati');
        }
      },
      error => {
        console.error(error);
      }
    );
  }


  /**
  * Fare una richiesta senza Ajax e senza aggiornare la pagina
  * Invisibile per l'utente
  * @param url string
  * @param params object
  * @param method string get or post
  **/
  requestWithoutAjax(url: string, params: Object, method: string) {
    //console.log('requestWithoutAjax');

    params = params || {};
    method = method || 'post';

    // function to remove the iframe
    let removeIframe = function (iframe) {
      iframe.parentElement.removeChild(iframe);
    };

    // make a iframe...
    let iframe = document.createElement('iframe');
    iframe.style.display = 'none';

    iframe.onload = function () {
      let iframeDoc = this.contentWindow.document;

      // Make a invisible form
      let form = iframeDoc.createElement('form');
      form.method = method;
      form.action = url;
      iframeDoc.body.appendChild(form);

      // pass the parameters
      // tslint:disable-next-line:forin
      for (let name in params) {
        let input = iframeDoc.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = params[name];
        form.appendChild(input);
      }

      form.submit();
      // remove the iframe
      setTimeout(function () {
        removeIframe(iframe);
      }, 500);
    };

    document.body.appendChild(iframe);
  }

  fileUpload(action: string, file: File) {

    const wsURL = this.session.outputUrl + '/' + action;

    console.log('fileUpload');

    const formData = new FormData();
    formData.append('file', file);

    return this._http.post(
      wsURL,
      formData, {
        headers: this.getHeaders()
      })
      .map(res => this.mapResponse(res))
      .catch(err => this.handleError(err));
  }

  requestAngular2(action: string, params: Object): Observable<any> {
    return this.requestAngular2Type<any>(action, params);
  }

  /*ANGULAR2 REQUEST*/
  requestAngular2Type<T>(action: string, params: Object): Observable<T> {
    let wsURL = this.session.outputUrl + '/' + action;

    console.log('requestAngular2Type - ' + action );
    return this._http.post(
      wsURL,
      params, {
        headers: this.getHeaders()
      })
      .map(res => this.mapResponse(res))
      .catch(err => this.handleError(err));
  }

  private getHeaders() {
    let headers = new Headers();
    headers.append('Accept', 'application/json');
    return headers;
  }

  private mapResponse(res: Response) {
    if (!res.ok) {
      console.log('requestAngular2Type- mapResponse');
      console.log(res);
      this.handleError(res);
    } else {
      return res.json();
    }
  }

  private handleError(error: any) {
    console.log('requestAngular2Type -handleError');
    console.log(error);
    let errMsg;

    if (!!error._body) {
      // errMsg = JSON.stringify(error._body);
      let errJson = JSON.parse(JSON.stringify(error._body || null)); // JSON.parse(error._body);
      errMsg = (errJson.ExceptionMessage) ? errJson.ExceptionMessage : error._body;
    } else {
      errMsg = (error.message) ? error.message :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    }

    console.log('error');
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }

  _keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    console.log(inputChar, event.charCode);
    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  validate(value) {
    console.log('validate-value: ' + value);

    if (value < 1) {
      this.cartService.cart.currentCartProduct.quantity = 1;
    } else if (value > 100) {
      this.cartService.cart.currentCartProduct.quantity = 100;
    } else {
      this.cartService.cart.currentCartProduct.quantity = value;
    }
  }

  validateCart(value, idRow) {
    console.log('validate-value: ' + value);

    let currentRow = this.cartService.cart.cartProducts.filter(r => r.idRow === idRow)[0];
    if (currentRow != null) {
      if (value < 1) {
        currentRow.quantity = 1;
      } else if (value > 100) {
        currentRow.quantity = 100;
      } else {
        currentRow.quantity = value;
      }
    }

    this.cartService.saveCart();
  }

  refreshValue(myComponentRef: HTMLInputElement, quantity: number) {
    console.log(myComponentRef);
    myComponentRef.value = quantity.toString();
  }



}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/commons/utilities.service.ts